import { render, staticRenderFns } from "./DoubleBorderBox.vue?vue&type=template&id=58988b58&scoped=true&"
import script from "./DoubleBorderBox.vue?vue&type=script&lang=js&"
export * from "./DoubleBorderBox.vue?vue&type=script&lang=js&"
import style0 from "./DoubleBorderBox.vue?vue&type=style&index=0&id=58988b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58988b58",
  null
  
)

export default component.exports